import { Tabs, TabsList, TabsTrigger } from "@themis/ui";
import React from "react";
import {
  generatePath,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";

import {
  PROJECT_DETAILS_PATH,
  PROJECT_TASKS_PATH,
  PROJECTS_LIST_PATH,
} from "@/features/projects/pages/ProjectRoutes";

function ProjectsHeader() {
  const { workspace_id } = useParams<{
    workspace_id: string;
  }>();
  const project_id = "1"; // temp value to use for paths until
  const { pathname } = useLocation();
  const history = useHistory();

  function handleTabChange(value: string) {
    history.push(value);
  }

  return (
    <Tabs
      className="tw-flex tw-items-center tw-bg-neutral-25 tw-px-6"
      onValueChange={handleTabChange}
      value={pathname}
    >
      <TabsList>
        {/* Render the Projects tab if pathname matches the base route */}
        {pathname === generatePath(PROJECTS_LIST_PATH, { workspace_id }) && (
          <TabsTrigger
            value={generatePath(PROJECTS_LIST_PATH, { workspace_id })}
          >
            Projects
          </TabsTrigger>
        )}

        {/* Check if pathname matches PROJECT_DETAILS_PATH or PROJECT_TASKS_PATH */}
        {[PROJECT_DETAILS_PATH, PROJECT_TASKS_PATH].some((path) =>
          pathname.includes(generatePath(path, { workspace_id, project_id })),
        ) && (
          <>
            <TabsTrigger
              value={generatePath(PROJECT_DETAILS_PATH, {
                workspace_id,
                project_id,
              })}
            >
              Project Details
            </TabsTrigger>
            <TabsTrigger
              value={generatePath(PROJECT_TASKS_PATH, {
                workspace_id,
                project_id,
              })}
            >
              Tasks
            </TabsTrigger>
          </>
        )}
      </TabsList>
    </Tabs>
  );
}

export default ProjectsHeader;
